import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../utils/checkout';

/**
 * Sticky checkout bar. Appears once the visitor scrolls past the first CTA
 * (the element with id "primary-cta") and shakes periodically to stay visible.
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('primary-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      const passed = entry.boundingClientRect.top < 0;
      setVisible(!entry.isIntersecting && passed);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-33" data-mp="195wszeeohtah">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-gold-500/30 bg-navy-950/95 px-3 pb-[calc(env(safe-area-inset-bottom)+10px)] pt-3 backdrop-blur" data-id="element-34" data-mp="196yde9hl3s4v">
          <div className="mx-auto flex max-w-2xl flex-col items-center" data-id="element-35" data-mp="21bkvt7diitno">
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="flex w-full animate-shake items-center justify-center rounded-xl bg-gold-500 px-4 py-3.5 text-center text-[14px] font-extrabold uppercase tracking-wide text-navy-950 shadow-[0_10px_30px_-10px_rgba(201,162,75,0.9)] transition-[background-color,transform] duration-200 ease-out hover:bg-gold-400 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-gold-500/50 active:scale-[0.985] sm:text-base" data-id="element-36" data-mp="26bgwawn042yh">
              Get the Playbook — $27 today
            </a>
            <p className="mt-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-slate-400" data-id="element-37" data-mp="3hpuk61hr8iei">
              One-time payment · Instant access · 7-day guarantee
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}